import React from 'react';
import { Field, ErrorMessage, FieldArray, useFormikContext } from 'formik';
import { Box, Grid, TextField, IconButton, Button, Tooltip, Stack, Paper, Typography } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export default function BehaviorsStep({ values }) {
    const { errors, touched } = useFormikContext();
    const fieldSx = { '& .MuiOutlinedInput-root': { borderRadius: '12px' } };

    return (
        <Box pt={2}>
            <FieldArray name="behaviors">
                {({ remove, push }) => (
                    <Stack spacing={2}>
                        {values.behaviors.map((behavior, index) => (
                            <Paper key={index} variant="outlined" sx={{ p: 2, borderRadius: '16px' }}>
                                <Grid container spacing={2} alignItems="flex-start">
                                    <Grid item xs>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            label={`Behavior #${index + 1}`}
                                            name={`behaviors[${index}].name`}
                                            helperText={
                                                <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                    <span><ErrorMessage name={`behaviors[${index}].name`} /></span>
                                                    <Typography variant="caption" sx={{ ml: 'auto' }}>
                                                        {`${behavior.name.length} / 50`}
                                                    </Typography>
                                                </Box>
                                            }
                                            error={touched.behaviors?.[index]?.name && Boolean(errors.behaviors?.[index]?.name)}
                                            sx={fieldSx}
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={3}>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            label="Weight"
                                            type="number"
                                            name={`behaviors[${index}].weight`}
                                            helperText={<ErrorMessage name={`behaviors[${index}].weight`} />}
                                            error={touched.behaviors?.[index]?.weight && Boolean(errors.behaviors?.[index]?.weight)}
                                            sx={fieldSx}
                                        />
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Tooltip title="Remove Behavior">
                                            <IconButton sx={{mt: 1}} onClick={() => values.behaviors.length > 1 && remove(index)} disabled={values.behaviors.length <= 1}>
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Paper>
                        ))}
                        <Button startIcon={<AddCircleOutlineIcon />} onClick={() => push({ name: '', weight: 5 })} sx={{ alignSelf: 'flex-start' }}>
                            Add Behavior
                        </Button>
                    </Stack>
                )}
            </FieldArray>
        </Box>
    );
}
